import Vue from 'vue';
import VueRx from 'vue-rx';
import Vuetify from 'vuetify';
import VueFlashMessage from 'vue-sweetalert2';


import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify, {
  iconfont: 'mdi',
});
Vue.use(VueRx);
Vue.use(VueFlashMessage);
